export default {
    props: {
        multiOffset: Boolean,
        active: {
            type: Object
        },
        stacked: Boolean,
        growDurations: {
            type: Number,
            default: 0.5
        },
        minBarHeight: {
            type: Number,
            default: 3
        },
        barColors: Object,
        noneColor: {
            type: String,
            default: '#000'
        },
        rounding: {
            type: Number,
            default: 2
        },
        barPaddingRate: {
            type: Number,
            default: 0.2
        },
        barLabelPadding: {
            type: Number,
            default: 10
        },
        barShadowFilter: {
            type: Boolean
        },
        barLabel: {
            type: Boolean
        }
    }
}
